import { SchoolI } from "@seneca/schools-service-types";

import { QueryOptions } from "../../../utils/reactQuery/types";
import { fetchMySchoolInfo } from "./client";

export type SchoolInfoQueryData = SchoolI | undefined;

export const fetchMySchoolInfoQueryOptions =
  (): QueryOptions<SchoolInfoQueryData> => ({
    queryFn: fetchMySchoolInfo,
    queryKey: ["schools", "fetchMySchoolInfo"],
    staleTime: Infinity
  });
